export default __webpack_public_path__ + "static/media/p15.745c2d03.jpeg";